module.exports = __webpack_public_path__ + "img/services.fbab1ca1.png";